import getAxiosAuthHeaders from '../../../functions/getAxiosAuthHeaders';
import api from '../../../apis/api';

const updateJobAttachment = async (jobId, attachment, attachmentId) => {
  const response = await api.put(
    `job/${jobId}/attachment/${attachmentId}`,
    { ...attachment },
    {
      headers: await getAxiosAuthHeaders(),
    }
  );
  if (response.data) {
    return response.data;
  }

  return null;
};

export default updateJobAttachment;
